import Socket from './Socket';

/*
建立 Socket 连接：

    let sock = new ZJNotify.TcpSocket('localhost', 80);
    sock.on('open', function (e) {
   	    sock.send('GET / HTTP/1.1\r\nHost: localhost:8080\r\n\r\n');
    });

    sock.on('close', function (e) {
   	    console.log('close', e);
    });

    sock.on('error', function (e) {
   	    console.log('error', e);
    });

    sock.on('recv', function (e) {
   	    let s = e.data.toUTF8String();
   	    console.log(s);
   	    sock.close();
    });

    sock.open();
*/

const TcpSocket = function() {
    this.$init.apply(this, arguments);
};

TcpSocket.prototype = new Socket('', 0, 'tcp');

export default TcpSocket;
